import { render, staticRenderFns } from "./uVersionHistory.vue?vue&type=template&id=8d977d66&scoped=true"
import script from "./uVersionHistory.vue?vue&type=script&lang=js"
export * from "./uVersionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d977d66",
  null
  
)

export default component.exports